import { useBoundStore } from '../../store/store';
import { __ } from '@wordpress/i18n';
import Tooltip from '../tooltip';

const { gp_conditional_pricing_form_settings_strings: strings } = window;

export function ImportPricingLevelsButton() {
	const { setActiveView } = useBoundStore();
	return (
		<button
			id="gpcp-import"
			className="button button-secondary large"
			disabled={!strings.supports_csvs}
			onClick={async (event: React.MouseEvent<HTMLButtonElement>) => {
				event.preventDefault();

				if (!strings.supports_csvs) {
					return;
				}

				setActiveView('importer.csv-import-form');
			}}
		>
			{__('Import Pricing', 'gp-conditional-pricing')}
			{!strings.supports_csvs && (
				<Tooltip
					content={__(
						'Importing requires PHP 7.4+ and the mbstring extension.',
						'gp-conditional-pricing'
					)}
				/>
			)}
		</button>
	);
}
